import { Injectable, NgZone } from '@angular/core';
import { AuthService } from './auth.service';
import { MyUserService } from '../my-user/my-user.service';
import { environment } from '../../../../environments/environment';
declare const io: any;

/** A session-only connection also reaches dashboards and other non-game pages.
 * It never initializes a Player or replaces a game's socket. */
@Injectable({providedIn:'root'})
export class SessionEventsService {
  private socket: any;
  private readonly connect = io.sails.connect.bind(io.sails);
  constructor(private auth: AuthService, private zone: NgZone, private myUser: MyUserService) {
    auth.isAuthenticated$.subscribe(loggedIn => {
      if (!loggedIn) { const old = this.socket; this.socket = undefined; old?.disconnect(); return; }
      if (this.socket) return;
      const socket = this.socket = this.connect(environment.SERVER_URL);
      const revoked = (message?: any) => { if (this.socket === socket) this.zone.run(() => { void this.auth.handleServerLogout(message?.data?.reason); }); };
      socket.on('logoff', revoked);
      socket.on('logout', revoked);
      socket.on('profilePictureChanged', () => { if (this.socket === socket) this.zone.run(() => { void this.myUser.update(); }); });
      let joined = false;
      socket.on('connect', () => socket.get('/user/auth/watch-session', (_body: any, response: any) => {
        if (response?.statusCode === 401) return revoked();
        // A new guest's picture can be published before this socket was in the room.
        if (!joined && this.socket === socket && this.auth.isGuest()) this.zone.run(() => { void this.myUser.update(); });
        joined = true;
      }));
    });
  }
}
